// Formata CPF (11 dígitos) ou CNPJ (14 dígitos) para exibição/digitação.
// O backend normaliza cpf_cnpj para conter só dígitos ao salvar, então esta
// função aceita valores já mascarados, só dígitos, nulos ou vazios.
export const formatCpfCnpj = (value) => {
  if (!value) return '';

  const cleaned = String(value).replace(/\D/g, '');

  if (cleaned.length === 11) {
    return cleaned.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  }

  if (cleaned.length === 14) {
    return cleaned.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
  }

  return cleaned;
};

export default formatCpfCnpj;
